module.exports = __webpack_public_path__ + "img/percent-down.aeb4cf6f.svg";